export default __webpack_public_path__ + "static/device-15d7889770975876e02ecc530e54426e.jpg";